

import React from "react";
import { Whatsapp } from "react-bootstrap-icons";
import "../../assets/css/WhatsappButton.css";


const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/4917670839415" // replace with your number
      className="whatsapp-button"
      target="_blank"
      rel="noopener noreferrer"
    >
      <Whatsapp size={28} />
    </a>
  );
};

export default WhatsAppButton;
